import Notes from './NotesContainer'

export default Notes
